import type { TFunction } from "i18next";
import { NS } from "../../../../U3121";

interface U3121BillingSummaryNoAccessPanelProps {
  messageKey: string;
  t: TFunction;
}

function U3121BillingSummaryNoAccessPanel({ messageKey, t }: U3121BillingSummaryNoAccessPanelProps) {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-muted/30 px-4 py-6 text-center text-sm text-muted-foreground">
      {t(messageKey, { ns: NS })}
    </div>
  );
}

export default U3121BillingSummaryNoAccessPanel;
